import axios from 'axios';
import store from '../store';
import request, { serializeGetParams } from './request';

// ==== 认证相关 ====
export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  });
}

export function getUserInfo() {
  return request({
    url: '/auth/userInfo',
    method: 'get'
  });
}

// ==== 控制面板 ====
export function getDashboardOverview() {
  return request({
    url: '/dashboard/overview',
    method: 'get'
  });
}

// ==== 学情分析（学校 / 年级 / 班级及讲评）====
export function getAnalysisSchoolOverview(params) {
  return request({
    url: '/analysis/school/overview',
    method: 'get',
    params
  });
}

export function getAnalysisGradeOverview(params) {
  return request({
    url: '/analysis/grade/overview',
    method: 'get',
    params
  });
}

export function getAnalysisClassOverview(params) {
  return request({
    url: '/analysis/class/overview',
    method: 'get',
    params
  });
}

export function getAnalysisClassReview(params) {
  return request({
    url: '/analysis/class/review',
    method: 'get',
    params
  });
}

// ==== 学情分析 — 单科报告 ====
export function getExamSessionReportList(params) {
  return request({
    url: '/analysis/exam-sessions',
    method: 'get',
    params
  });
}

export function getExamSessionReportMeta(examSessionId) {
  return request({
    url: `/analysis/exam-sessions/${examSessionId}/meta`,
    method: 'get'
  });
}

export function getExamSessionReportPrecision(examSessionId, params) {
  return request({
    url: `/analysis/exam-sessions/${examSessionId}/precision`,
    method: 'get',
    params
  });
}

export function getExamSessionReportReview(examSessionId, params) {
  return request({
    url: `/analysis/exam-sessions/${examSessionId}/review`,
    method: 'get',
    params
  });
}

export function toggleExamSessionReviewMark(examSessionId, data) {
  return request({
    url: `/analysis/exam-sessions/${examSessionId}/review/mark`,
    method: 'post',
    data
  });
}

export function getExamSessionReviewQuestionResponse(examSessionId, questionKey, params) {
  return request({
    url: `/analysis/exam-sessions/${examSessionId}/review/questions/${encodeURIComponent(questionKey)}/response`,
    method: 'get',
    params
  });
}

export function getExamSessionReviewSimilarQuestions(examSessionId, questionKey, params) {
  return request({
    url: `/analysis/exam-sessions/${examSessionId}/review/questions/${encodeURIComponent(questionKey)}/similar`,
    method: 'get',
    params
  });
}

export function getExamSessionReportCompareOptions(examSessionId) {
  return request({
    url: `/analysis/exam-sessions/${examSessionId}/compare-options`,
    method: 'get'
  });
}

export function getExamSessionReportBasic(examSessionId, params) {
  return request({
    url: `/analysis/exam-sessions/${examSessionId}/basic`,
    method: 'get',
    params
  });
}

export function getExamSessionReportPaper(examSessionId, params) {
  return request({
    url: `/analysis/exam-sessions/${examSessionId}/paper`,
    method: 'get',
    params
  });
}

export function getExamSessionReportCustom(examSessionId, params) {
  return request({
    url: `/analysis/exam-sessions/${examSessionId}/custom`,
    method: 'get',
    params,
    paramsSerializer: serializeGetParams
  });
}

export function getExamSessionReportScoreSheet(examSessionId, params) {
  return request({
    url: `/analysis/exam-sessions/${examSessionId}/score-sheet`,
    method: 'get',
    params
  });
}

export function getExamSessionStudentPersonalReport(examSessionId, studentId, params) {
  return request({
    url: `/analysis/exam-sessions/${examSessionId}/students/${studentId}/personal-report`,
    method: 'get',
    params
  });
}

export function getExamSessionStudentAnswerSheetImages(examSessionId, studentId, params) {
  return request({
    url: `/analysis/exam-sessions/${examSessionId}/students/${studentId}/answer-sheet-images`,
    method: 'get',
    params
  });
}

// ==== 学情分析 — 多科报告 ====
export function getMultiSubjectReportList(params) {
  return request({
    url: '/analysis/multi-subject/reports',
    method: 'get',
    params
  });
}

export function getMultiSubjectReportDetail(id) {
  return request({
    url: `/analysis/multi-subject/reports/${id}`,
    method: 'get'
  });
}

export function createMultiSubjectReport(data) {
  return request({
    url: '/analysis/multi-subject/reports',
    method: 'post',
    data
  });
}

export function updateMultiSubjectReport(id, data) {
  return request({
    url: `/analysis/multi-subject/reports/${id}`,
    method: 'put',
    data
  });
}

export function deleteMultiSubjectReport(id) {
  return request({
    url: `/analysis/multi-subject/reports/${id}`,
    method: 'delete'
  });
}

export function getMultiSubjectExamOptions(params) {
  return request({
    url: '/analysis/multi-subject/exam-options',
    method: 'get',
    params
  });
}

export function getMultiSubjectReportMeta(reportId) {
  return request({
    url: `/analysis/multi-subject/reports/${reportId}/meta`,
    method: 'get'
  });
}

export function getMultiSubjectReportPrecision(reportId, params) {
  return request({
    url: `/analysis/multi-subject/reports/${reportId}/precision`,
    method: 'get',
    params
  });
}

export function getMultiSubjectReportBasic(reportId, params) {
  return request({
    url: `/analysis/multi-subject/reports/${reportId}/basic`,
    method: 'get',
    params
  });
}

export function getMultiSubjectReportScoreSheet(reportId, params) {
  return request({
    url: `/analysis/multi-subject/reports/${reportId}/score-sheet`,
    method: 'get',
    params
  });
}

export function getMultiSubjectStudentPersonalReport(reportId, studentId, params) {
  return request({
    url: `/analysis/multi-subject/reports/${reportId}/students/${studentId}/personal`,
    method: 'get',
    params
  });
}

// ==== 角色管理 ====
export function fetchRoles(params) {
  return request({
    url: '/auth/roles',
    method: 'get',
    params
  });
}

export function createRole(data) {
  return request({
    url: '/auth/roles',
    method: 'post',
    data
  });
}

export function updateRole(id, data) {
  return request({
    url: `/auth/roles/${id}`,
    method: 'put',
    data
  });
}

export function deleteRole(id) {
  return request({
    url: `/auth/roles/${id}`,
    method: 'delete'
  });
}

export function getRoleMenus(id) {
  return request({
    url: `/auth/roles/${id}/menus`,
    method: 'get'
  });
}

export function assignRoleMenus(id, data) {
  return request({
    url: `/auth/roles/${id}/menus`,
    method: 'put',
    data
  });
}

// ==== 菜单管理 ====
export function fetchMenuTree() {
  return request({
    url: '/auth/menus/tree',
    method: 'get'
  });
}

export function createMenu(data) {
  return request({
    url: '/auth/menus',
    method: 'post',
    data
  });
}

export function updateMenu(id, data) {
  return request({
    url: `/auth/menus/${id}`,
    method: 'put',
    data
  });
}

export function deleteMenu(id) {
  return request({
    url: `/auth/menus/${id}`,
    method: 'delete'
  });
}

// ==== 系统用户管理 ====
export function fetchSysUsers(params) {
  return request({
    url: '/system/users',
    method: 'get',
    params
  });
}

export function createSysUser(data) {
  return request({
    url: '/system/users',
    method: 'post',
    data
  });
}

export function updateSysUser(id, data) {
  return request({
    url: `/system/users/${id}`,
    method: 'put',
    data
  });
}

export function deleteSysUser(id) {
  return request({
    url: `/system/users/${id}`,
    method: 'delete'
  });
}

// ==== 用户-角色关系 ====
export function getUserRoleIds(userId) {
  return request({
    url: `/auth/users/${userId}/roles`,
    method: 'get'
  });
}

export function assignUserRoles(userId, data) {
  return request({
    url: `/auth/users/${userId}/roles`,
    method: 'put',
    data
  });
}


// ==== 代理商管理 ====
export function fetchAgents(params) {
  return request({
    url: '/tenant/agents',
    method: 'get',
    params
  });
}

// ==== 学校管理 ====
export function fetchSchools(params) {
  return request({
    url: '/tenant/schools',
    method: 'get',
    params
  });
}

export function createSchool(data) {
  return request({
    url: '/tenant/schools',
    method: 'post',
    data
  });
}

export function updateSchool(id, data) {
  return request({
    url: `/tenant/schools/${id}`,
    method: 'put',
    data
  });
}

export function deleteSchool(id) {
  return request({
    url: `/tenant/schools/${id}`,
    method: 'delete'
  });
}

// ==== 教职工管理 ====
export function fetchStaff(params) {
  return request({
    url: '/tenant/staff',
    method: 'get',
    params
  });
}

export function createStaff(data) {
  return request({
    url: '/tenant/staff',
    method: 'post',
    data
  });
}

export function updateStaff(id, data) {
  return request({
    url: `/tenant/staff/${id}`,
    method: 'put',
    data
  });
}

export function updateStaffStatus(id, status) {
  return request({
    url: `/tenant/staff/${id}/status`,
    method: 'put',
    data: { status }
  });
}

export function deleteStaff(id) {
  return request({
    url: `/tenant/staff/${id}`,
    method: 'delete'
  });
}

export function createAgent(data) {
  return request({
    url: '/tenant/agents',
    method: 'post',
    data
  });
}

export function updateAgent(id, data) {
  return request({
    url: `/tenant/agents/${id}`,
    method: 'put',
    data
  });
}

export function deleteAgent(id) {
  return request({
    url: `/tenant/agents/${id}`,
    method: 'delete'
  });
}

// ==== 年级管理 ====
export function fetchGrades(params) {
  return request({
    url: '/tenant/grades',
    method: 'get',
    params
  });
}

export function createGrade(data) {
  return request({
    url: '/tenant/grades',
    method: 'post',
    data
  });
}

export function updateGrade(id, data) {
  return request({
    url: `/tenant/grades/${id}`,
    method: 'put',
    data
  });
}

export function deleteGrade(id) {
  return request({
    url: `/tenant/grades/${id}`,
    method: 'delete'
  });
}

// ==== 联考管理 ====
export function fetchExamJoints(params) {
  return request({
    url: '/exam/joints',
    method: 'get',
    params
  });
}

export function getExamJoint(id) {
  return request({
    url: `/exam/joints/${id}`,
    method: 'get'
  });
}

export function createExamJoint(data) {
  return request({
    url: '/exam/joints',
    method: 'post',
    data
  });
}

export function updateExamJoint(id, data) {
  return request({
    url: `/exam/joints/${id}`,
    method: 'put',
    data
  });
}

export function deleteExamJoint(id) {
  return request({
    url: `/exam/joints/${id}`,
    method: 'delete'
  });
}

export function setExamJointOpened(id, opened) {
  return request({
    url: `/exam/joints/${id}/opened`,
    method: 'put',
    data: { opened }
  });
}

export function fetchExamJointSchools(jointId) {
  return request({
    url: `/exam/joints/${jointId}/schools`,
    method: 'get'
  });
}

export function addExamJointSchools(jointId, schoolIds) {
  return request({
    url: `/exam/joints/${jointId}/schools`,
    method: 'post',
    data: { schoolIds }
  });
}

export function removeExamJointSchool(jointId, schoolId) {
  return request({
    url: `/exam/joints/${jointId}/schools/${schoolId}`,
    method: 'delete'
  });
}

export function updateExamJointSchoolStatus(jointId, schoolId, status) {
  return request({
    url: `/exam/joints/${jointId}/schools/${schoolId}/status`,
    method: 'put',
    data: { status }
  });
}

export function fetchExamJointSessions(jointId) {
  return request({
    url: `/exam/joints/${jointId}/sessions`,
    method: 'get'
  });
}

export function bindExamJointSessions(jointId, examSessionIds) {
  return request({
    url: `/exam/joints/${jointId}/sessions`,
    method: 'post',
    data: { examSessionIds }
  });
}

export function unbindExamJointSession(jointId, examSessionId) {
  return request({
    url: `/exam/joints/${jointId}/sessions/${examSessionId}`,
    method: 'delete'
  });
}

export function fetchExamJointBindCandidates(jointId, params) {
  return request({
    url: `/exam/joints/${jointId}/bind-candidates`,
    method: 'get',
    params
  });
}

export function fetchExamJointProgress(jointId) {
  return request({
    url: `/exam/joints/${jointId}/progress`,
    method: 'get'
  });
}

export function fetchExamJointAnalysisSummary(jointId) {
  return request({
    url: `/exam/joints/${jointId}/analysis-summary`,
    method: 'get'
  });
}

export function setExamJointAnalysisVisible(id, visible) {
  return request({
    url: `/exam/joints/${id}/analysis-visible`,
    method: 'put',
    data: { visible }
  });
}

export function createExamJointMultiSubjectReport(jointId, data) {
  return request({
    url: `/exam/joints/${jointId}/multi-subject-report`,
    method: 'post',
    data: data || {}
  });
}

export function fetchExamJointSchoolRankings(jointId, params) {
  return request({
    url: `/exam/joints/${jointId}/rankings/schools`,
    method: 'get',
    params
  });
}

export function fetchExamJointStudentRankings(jointId, params) {
  return request({
    url: `/exam/joints/${jointId}/rankings/students`,
    method: 'get',
    params
  });
}

export function fetchExamJointScoreBands(jointId, params) {
  return request({
    url: `/exam/joints/${jointId}/score-bands`,
    method: 'get',
    params
  });
}

export function exportExamJointAnalysis(jointId, params) {
  return request({
    url: `/exam/joints/${jointId}/export`,
    method: 'get',
    params,
    responseType: 'blob',
    timeout: 120000
  });
}

// ==== 个性组卷 ====
export function fetchPerExercises(params) {
  return request({
    url: '/personal/exercises',
    method: 'get',
    params
  });
}

export function getPerExerciseDetail(id) {
  return request({
    url: `/personal/exercises/${id}`,
    method: 'get'
  });
}

export function syncPerExerciseToPaper(id) {
  return request({
    url: `/personal/exercises/${id}/sync-to-paper`,
    method: 'post'
  });
}

export function createPerExercise(data) {
  return request({
    url: '/personal/exercises',
    method: 'post',
    data
  });
}

export function updatePerExercise(id, data) {
  return request({
    url: `/personal/exercises/${id}`,
    method: 'put',
    data
  });
}

export function deletePerExercise(id) {
  return request({
    url: `/personal/exercises/${id}`,
    method: 'delete'
  });
}

// ==== 班级管理 ====
export function fetchClasses(params) {
  return request({
    url: '/tenant/classes',
    method: 'get',
    params
  });
}

export function createClass(data) {
  return request({
    url: '/tenant/classes',
    method: 'post',
    data
  });
}

export function batchCreateClasses(data) {
  return request({
    url: '/tenant/classes/batch',
    method: 'post',
    data
  });
}

export function updateClass(id, data) {
  return request({
    url: `/tenant/classes/${id}`,
    method: 'put',
    data
  });
}

export function deleteClass(id) {
  return request({
    url: `/tenant/classes/${id}`,
    method: 'delete'
  });
}

// ==== 学生学籍管理 ====
export function fetchStudents(params) {
  return request({
    url: '/tenant/students',
    method: 'get',
    params
  });
}

export function createStudent(data) {
  return request({
    url: '/tenant/students',
    method: 'post',
    data
  });
}

export function getStudentById(id) {
  return request({
    url: `/tenant/students/${id}`,
    method: 'get'
  });
}

export function updateStudent(id, data) {
  return request({
    url: `/tenant/students/${id}`,
    method: 'put',
    data
  });
}

export function deleteStudent(id) {
  return request({
    url: `/tenant/students/${id}`,
    method: 'delete'
  });
}

export function exportStudents(params) {
  return request({
    url: '/tenant/students/export',
    method: 'get',
    params,
    responseType: 'blob'
  });
}

export function importStudents(formData, schoolId) {
  return request({
    url: '/tenant/students/import',
    method: 'post',
    data: formData,
    params: { schoolId }
  });
}

export function downloadStudentImportTemplate() {
  return request({
    url: '/tenant/students/import/template',
    method: 'get',
    responseType: 'blob'
  });
}

/** 学生照片等：上传至阿里云 OSS（multipart 字段名 file） */
export function uploadOssImage(file) {
  const formData = new FormData();
  formData.append('file', file);
  return request({
    url: '/common/oss/upload/image',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000
  });
}

/** 同源代理拉取 OSS 图片字节（供 Canvas 合成批注图） */
export function fetchOssImageBlob(url) {
  return request({
    url: '/common/oss/fetch',
    method: 'get',
    params: { url },
    responseType: 'blob',
    timeout: 120000
  });
}

/** 视频上传至阿里云 OSS（multipart 字段名 file） */
export function uploadOssVideo(file) {
  const formData = new FormData();
  formData.append('file', file);
  return request({
    url: '/common/oss/upload/video',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 300000
  });
}

/** 通用文件上传至阿里云 OSS（multipart 字段名 file） */
export function uploadOssFile(file) {
  const formData = new FormData();
  formData.append('file', file);
  return request({
    url: '/common/oss/upload/file',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 300000
  });
}

// ==== 视频管理 ====
export function fetchVideos(params) {
  return request({
    url: '/resource/videos',
    method: 'get',
    params
  });
}

export function getVideoDetail(id) {
  return request({
    url: `/resource/videos/${id}`,
    method: 'get'
  });
}

export function createVideo(data) {
  return request({
    url: '/resource/videos',
    method: 'post',
    data
  });
}

export function updateVideo(id, data) {
  return request({
    url: `/resource/videos/${id}`,
    method: 'put',
    data
  });
}

export function deleteVideo(id) {
  return request({
    url: `/resource/videos/${id}`,
    method: 'delete'
  });
}

// ==== 试卷录入 ====
export function fetchPaperEntryTasks(params) {
  return request({
    url: '/resource/paper-entry-tasks',
    method: 'get',
    params
  });
}

export function createPaperEntryTask(data) {
  return request({
    url: '/resource/paper-entry-tasks',
    method: 'post',
    data
  });
}

export function updatePaperEntryTask(id, data) {
  return request({
    url: `/resource/paper-entry-tasks/${id}`,
    method: 'put',
    data
  });
}

export function deletePaperEntryTask(id) {
  return request({
    url: `/resource/paper-entry-tasks/${id}`,
    method: 'delete'
  });
}

// ==== 套卷管理 ====
export function fetchPaperSets(params) {
  return request({
    url: '/resource/paper-sets',
    method: 'get',
    params
  });
}

export function createPaperSet(data) {
  return request({
    url: '/resource/paper-sets',
    method: 'post',
    data
  });
}

export function updatePaperSet(id, data) {
  return request({
    url: `/resource/paper-sets/${id}`,
    method: 'put',
    data
  });
}

export function deletePaperSet(id) {
  return request({
    url: `/resource/paper-sets/${id}`,
    method: 'delete'
  });
}

export function fetchPaperSetFiles(id) {
  return request({
    url: `/resource/paper-sets/${id}/files`,
    method: 'get'
  });
}

export function createPaperSetFile(id, data) {
  return request({
    url: `/resource/paper-sets/${id}/files`,
    method: 'post',
    data
  });
}

export function updatePaperSetFile(id, data) {
  return request({
    url: `/resource/paper-sets/files/${id}`,
    method: 'put',
    data
  });
}

export function deletePaperSetFile(id) {
  return request({
    url: `/resource/paper-sets/files/${id}`,
    method: 'delete'
  });
}

// ==== 易错题联系（错题-学生关联） ====
export function fetchEasyMistakeRelations(params) {
  return request({
    url: '/resource/easy-mistake-relations',
    method: 'get',
    params
  });
}

export function createEasyMistakeRelation(data) {
  return request({
    url: '/resource/easy-mistake-relations',
    method: 'post',
    data
  });
}

export function updateEasyMistakeRelation(id, data) {
  return request({
    url: `/resource/easy-mistake-relations/${id}`,
    method: 'put',
    data
  });
}

export function deleteEasyMistakeRelation(id) {
  return request({
    url: `/resource/easy-mistake-relations/${id}`,
    method: 'delete'
  });
}

// ==== 错题统计 ====
export function fetchWrongQuestionStats(params) {
  return request({
    url: '/resource/error-question-stats',
    method: 'get',
    params
  });
}

export function fetchWrongQuestionStatSummary(params) {
  return request({
    url: '/resource/error-question-stats/summary',
    method: 'get',
    params
  });
}

export function fetchWrongQuestionStatDetail(id) {
  return request({
    url: `/resource/error-question-stats/${id}`,
    method: 'get'
  });
}

export function fetchStudentErrorBook(studentId, params) {
  return request({
    url: `/resource/error-question-stats/students/${studentId}`,
    method: 'get',
    params
  });
}

/** 学生错题本列表；studentId 可选，默认按数据范围查全部 */
export function fetchStudentErrorBookList(params) {
  return request({
    url: '/resource/error-question-stats/students',
    method: 'get',
    params
  });
}

export function migrateHomeworkWrongSnapshots() {
  return request({
    url: '/resource/error-question-stats/migrate-homework-snapshots',
    method: 'post'
  });
}

export function materializeErrorQuestion(id) {
  return request({
    url: `/resource/error-question-stats/${id}/materialize-question`,
    method: 'post'
  });
}

export function addErrorQuestionToBasket(id) {
  return request({
    url: `/resource/error-question-stats/${id}/add-to-basket`,
    method: 'post'
  });
}

// ==== 移动端用户 ====
export function fetchMobileUsers(params) {
  return request({
    url: '/user/mobile',
    method: 'get',
    params
  });
}

export function createMobileUser(data) {
  return request({
    url: '/user/mobile',
    method: 'post',
    data
  });
}

export function updateMobileUser(id, data) {
  return request({
    url: `/user/mobile/${id}`,
    method: 'put',
    data
  });
}

export function deleteMobileUser(id) {
  return request({
    url: `/user/mobile/${id}`,
    method: 'delete'
  });
}

// ==== 会员信息 ====
export function fetchMembers(params) {
  return request({
    url: '/user/member',
    method: 'get',
    params
  });
}

export function createMember(data) {
  return request({
    url: '/user/member',
    method: 'post',
    data
  });
}

export function updateMember(id, data) {
  return request({
    url: `/user/member/${id}`,
    method: 'put',
    data
  });
}

export function deleteMember(id) {
  return request({
    url: `/user/member/${id}`,
    method: 'delete'
  });
}

// ==== 手机绑定 ====
export function fetchMobileBinds(params) {
  return request({
    url: '/user/mobile-bind',
    method: 'get',
    params
  });
}

export function createMobileBind(data) {
  return request({
    url: '/user/mobile-bind',
    method: 'post',
    data
  });
}

export function updateMobileBind(id, data) {
  return request({
    url: `/user/mobile-bind/${id}`,
    method: 'put',
    data
  });
}

export function deleteMobileBind(id) {
  return request({
    url: `/user/mobile-bind/${id}`,
    method: 'delete'
  });
}

// ==== 个人中心 & 待办 ====
export function fetchTodos(params) {
  return request({
    url: '/personal/todos',
    method: 'get',
    params
  });
}

export function fetchTodoCount() {
  return request({
    url: '/personal/todos/count',
    method: 'get'
  });
}

export function markTodoDone(id) {
  return request({
    url: `/personal/todos/${id}/done`,
    method: 'put'
  });
}

// ==== 后台操作日志 ====
export function fetchSysUserLogs(params) {
  return request({
    url: '/monitor/logs',
    method: 'get',
    params
  });
}

// ==== 系统异常 ====
export function fetchSysExceptions(params) {
  return request({
    url: '/monitor/exceptions',
    method: 'get',
    params
  });
}

// ==== 题目管理 ====
export function fetchQuestions(params) {
  return request({
    url: '/resource/questions',
    method: 'get',
    params
  });
}

export function syncXkwQuestions(data) {
  return request({
    url: '/resource/questions/sync-xkw',
    method: 'post',
    data
  });
}

export function getQuestionDetail(id) {
  return request({
    url: `/resource/questions/${id}`,
    method: 'get'
  });
}

export function createQuestion(data, params) {
  return request({
    url: '/resource/questions',
    method: 'post',
    data,
    params
  });
}

export function updateQuestion(id, data) {
  return request({
    url: `/resource/questions/${id}`,
    method: 'put',
    data
  });
}

export function deleteQuestion(id) {
  return request({
    url: `/resource/questions/${id}`,
    method: 'delete'
  });
}

export function migrateQuestion(id, params) {
  return request({
    url: `/resource/questions/${id}/migrate`,
    method: 'post',
    params
  });
}

export function fetchQuestionChildren(id) {
  return request({
    url: `/resource/questions/${id}/children`,
    method: 'get'
  });
}

// ==== 试题篮（持久化） ====
export function fetchQuestionBasketMeta() {
  return request({
    url: '/resource/question-basket/meta',
    method: 'get'
  });
}

export function fetchQuestionBasket() {
  return request({
    url: '/resource/question-basket',
    method: 'get'
  });
}

export function addQuestionBasketItem(questionId) {
  return request({
    url: `/resource/question-basket/items/${questionId}`,
    method: 'post'
  });
}

export function removeQuestionBasketItem(questionId) {
  return request({
    url: `/resource/question-basket/items/${questionId}`,
    method: 'delete'
  });
}

export function clearQuestionBasket() {
  return request({
    url: '/resource/question-basket/items',
    method: 'delete'
  });
}

/** 设置试题篮关联的当前编辑试卷（进入组卷中心 / 章节挑题与同一套试卷同步） */
export function setQuestionBasketContext(data) {
  return request({
    url: '/resource/question-basket/context',
    method: 'put',
    data: data || {}
  });
}

export function clearQuestionBasketSession() {
  return request({
    url: '/resource/question-basket/session',
    method: 'delete'
  });
}

export function reorderQuestionBasket(questionIds) {
  return request({
    url: '/resource/question-basket/order',
    method: 'put',
    data: questionIds
  });
}

export function createPaperFromQuestionBasket(data) {
  return request({
    url: '/resource/question-basket/create-paper',
    method: 'post',
    data: data || {}
  });
}

// ==== 题目收藏 ====
export function addQuestionFavorite(questionId) {
  return request({
    url: `/resource/question-favorites/${questionId}`,
    method: 'post'
  });
}

export function removeQuestionFavorite(questionId) {
  return request({
    url: `/resource/question-favorites/${questionId}`,
    method: 'delete'
  });
}

export function checkQuestionFavorite(questionId) {
  return request({
    url: `/resource/question-favorites/${questionId}/check`,
    method: 'get'
  });
}

/** 批量查询收藏态，body 为题目 ID 数组 */
export function checkQuestionFavoriteBatch(questionIds) {
  return request({
    url: '/resource/question-favorites/batch-check',
    method: 'post',
    data: questionIds || []
  });
}

// ==== 试卷管理 ====
export function fetchPapers(params) {
  return request({
    url: '/resource/papers',
    method: 'get',
    params
  });
}

export function getPaperDetail(id) {
  return request({
    url: `/resource/papers/${id}`,
    method: 'get'
  });
}

export function createPaper(data) {
  return request({
    url: '/resource/papers',
    method: 'post',
    data
  });
}

export function updatePaper(id, data) {
  return request({
    url: `/resource/papers/${id}`,
    method: 'put',
    data
  });
}

export function deletePaper(id) {
  return request({
    url: `/resource/papers/${id}`,
    method: 'delete'
  });
}

export function composePaper(data) {
  return request({
    url: '/resource/papers/compose',
    method: 'post',
    data
  });
}

// ==== 智能挑题 ====
export function fetchSmartPickTemplates(params) {
  return request({
    url: '/resource/smart-pick/templates',
    method: 'get',
    params
  });
}

export function createSmartPickTemplate(data) {
  return request({
    url: '/resource/smart-pick/templates',
    method: 'post',
    data
  });
}

export function deleteSmartPickTemplate(id) {
  return request({
    url: `/resource/smart-pick/templates/${id}`,
    method: 'delete'
  });
}

export function generateSmartPickPaper(data) {
  return request({
    url: '/resource/smart-pick/generate',
    method: 'post',
    data
  });
}

export function completeDraftPaper(id) {
  return request({
    url: `/resource/papers/${id}/complete`,
    method: 'post'
  });
}

/** 草稿原地完成组卷（不克隆新卷） */
export function completeDraftPaperInPlace(id) {
  return request({
    url: `/resource/papers/${id}/complete-in-place`,
    method: 'post'
  });
}

export function fetchPaperComposeDetail(id) {
  return request({
    url: `/resource/papers/${id}/compose-detail`,
    method: 'get'
  });
}

export function exportPaperWord(id, data) {
  return request({
    url: `/resource/papers/${id}/export-word`,
    method: 'post',
    data,
    responseType: 'blob'
  });
}

export function fetchPaperSections(id) {
  return request({
    url: `/resource/papers/${id}/sections`,
    method: 'get'
  });
}

export function createPaperSection(id, data) {
  return request({
    url: `/resource/papers/${id}/sections`,
    method: 'post',
    data
  });
}

export function updatePaperSection(sectionId, data) {
  return request({
    url: `/resource/papers/sections/${sectionId}`,
    method: 'put',
    data
  });
}

export function deletePaperSection(sectionId) {
  return request({
    url: `/resource/papers/sections/${sectionId}`,
    method: 'delete'
  });
}

export function fetchPaperQuestionItems(id) {
  return request({
    url: `/resource/papers/${id}/questions`,
    method: 'get'
  });
}

export function addPaperQuestionItem(id, data) {
  return request({
    url: `/resource/papers/${id}/questions`,
    method: 'post',
    data
  });
}

export function addPaperQuestionItemsBatch(id, data) {
  return request({
    url: `/resource/papers/${id}/questions/batch`,
    method: 'post',
    data
  });
}

export function updatePaperQuestionItem(relationId, data) {
  return request({
    url: `/resource/papers/questions/${relationId}`,
    method: 'put',
    data
  });
}

export function deletePaperQuestionItem(relationId) {
  return request({
    url: `/resource/papers/questions/${relationId}`,
    method: 'delete'
  });
}

// ==== 学历学科 ====
export function fetchSubjects(params) {
  return request({
    url: '/dict/subjects',
    method: 'get',
    params
  });
}

/** 学历学科树。后端默认仅返回启用节点；管理页「全部」需传 allStatuses:true，见 SubjectList */
export function fetchSubjectTree(params) {
  return request({
    url: '/dict/subjects/tree',
    method: 'get',
    params
  });
}

export function createSubject(data) {
  return request({
    url: '/dict/subjects',
    method: 'post',
    data
  });
}

export function updateSubject(id, data) {
  return request({
    url: `/dict/subjects/${id}`,
    method: 'put',
    data
  });
}

export function deleteSubject(id) {
  return request({
    url: `/dict/subjects/${id}`,
    method: 'delete'
  });
}

// ==== 行政区划 ====
export function fetchRegions(params) {
  return request({
    url: '/dict/regions',
    method: 'get',
    params
  });
}

export function fetchRegionTree(params) {
  return request({
    url: '/dict/regions/tree',
    method: 'get',
    params
  });
}

/** 行政区划懒加载子节点；parentId 为空返回根层 */
export function fetchRegionChildren(params) {
  return request({
    url: '/dict/regions/children',
    method: 'get',
    params
  });
}

export function createRegion(data) {
  return request({
    url: '/dict/regions',
    method: 'post',
    data
  });
}

export function updateRegion(id, data) {
  return request({
    url: `/dict/regions/${id}`,
    method: 'put',
    data
  });
}

export function deleteRegion(id) {
  return request({
    url: `/dict/regions/${id}`,
    method: 'delete'
  });
}

/** 学科网：同步行政区划 → d_region */
export function xkwDictSyncRegions() {
  return request({
    url: '/dict/xkw/sync/regions',
    method: 'post'
  });
}

/** 学科网：同步学段 → d_subject（type=stage） */
export function xkwDictSyncStages() {
  return request({
    url: '/dict/xkw/sync/stages',
    method: 'post'
  });
}

/**
 * 学科网：同步学科（课程）→ d_subject。
 * 不传 parentStageId：按接口返回的学段字段自动关联本地学段；传入则只挂到该学段下。
 */
export function xkwDictSyncCourses(parentStageId) {
  const params = {};
  if (parentStageId != null && parentStageId !== '') {
    params.parentStageId = parentStageId;
  }
  return request({
    url: '/dict/xkw/sync/courses',
    method: 'post',
    params
  });
}

/** 学科网：同步指定学科的教材版本与目录 */
export function xkwDictSyncTextbooksAndCatalog(subjectId, replaceCatalog = false) {
  return request({
    url: '/dict/xkw/sync/textbooks/all',
    method: 'post',
    params: { subjectId, replaceCatalog }
  });
}

/** 学科网：同步指定学科的教材版本（不含目录） */
export function xkwDictSyncTextbooks(subjectId) {
  return request({
    url: '/dict/xkw/sync/textbooks',
    method: 'post',
    params: { subjectId }
  });
}

/** 学科网：按教材版本同步目录 */
export function xkwDictSyncCatalog(versionId, replace = false) {
  return request({
    url: '/dict/xkw/sync/catalog',
    method: 'post',
    params: { versionId, replace }
  });
}

/** 学科网：按学科同步知识树 → d_knowledge_node */
export function xkwDictSyncKnowledge(subjectId) {
  return request({
    url: '/dict/xkw/sync/knowledge',
    method: 'post',
    params: { subjectId }
  });
}

/** 学科网：同步试卷类型（可选按学科） */
export function xkwDictSyncPaperTypes() {
  return request({
    url: '/dict/xkw/sync/paper-types',
    method: 'post'
  });
}

/** 学科网：同步题目类型（可选按学科） */
export function xkwDictSyncQuestionTypes(subjectId) {
  const params = {};
  if (subjectId != null && subjectId !== '') {
    params.subjectId = subjectId;
  }
  return request({
    url: '/dict/xkw/sync/question-types',
    method: 'post',
    params
  });
}

/** 学科网对接状态（是否启用、接口是否配置等） */
export function fetchXkwDictStatus() {
  return request({
    url: '/dict/xkw/status',
    method: 'get'
  });
}

// ==== 教材版本与目录 ====
export function fetchTextbookVersions(params) {
  return request({
    url: '/dict/textbooks/versions',
    method: 'get',
    params
  });
}

export function createTextbookVersion(data) {
  return request({
    url: '/dict/textbooks/versions',
    method: 'post',
    data
  });
}

export function updateTextbookVersion(id, data) {
  return request({
    url: `/dict/textbooks/versions/${id}`,
    method: 'put',
    data
  });
}

export function deleteTextbookVersion(id) {
  return request({
    url: `/dict/textbooks/versions/${id}`,
    method: 'delete'
  });
}

/** 教材/知识点全量树 GET：同参并发共用 Promise，成功结果会话内缓存 */
const dictTreeGetCache = new Map();

function cachedDictTreeGet(url, params) {
  const key = url + JSON.stringify(params || {});
  if (dictTreeGetCache.has(key)) {
    return dictTreeGetCache.get(key);
  }
  const p = request({
    url,
    method: 'get',
    params
  }).then(
    (res) => res,
    (err) => {
      dictTreeGetCache.delete(key);
      throw err;
    }
  );
  dictTreeGetCache.set(key, p);
  return p;
}

/** 写操作 / 同步后清会话缓存，避免字典页读到旧树 */
export function clearDictTreeGetCache() {
  dictTreeGetCache.clear();
}

export function fetchTextbookNodeTree(params) {
  return cachedDictTreeGet('/dict/textbooks/nodes/tree', params);
}

export function fetchTextbookNodeChildren(params) {
  return cachedDictTreeGet('/dict/textbooks/nodes/children', params);
}

export function fetchTextbookNodePath(id) {
  return cachedDictTreeGet(`/dict/textbooks/nodes/${id}/path`, {});
}

export function createTextbookNode(data) {
  return request({
    url: '/dict/textbooks/nodes',
    method: 'post',
    data
  });
}

export function updateTextbookNode(id, data) {
  return request({
    url: `/dict/textbooks/nodes/${id}`,
    method: 'put',
    data
  });
}

export function deleteTextbookNode(id) {
  return request({
    url: `/dict/textbooks/nodes/${id}`,
    method: 'delete'
  });
}

// ==== 试卷类型 / 题目类型 ====
export function fetchPaperTypes(params) {
  return request({
    url: '/dict/paper-types',
    method: 'get',
    params
  });
}

export function createPaperType(data) {
  return request({
    url: '/dict/paper-types',
    method: 'post',
    data
  });
}

export function updatePaperType(id, data) {
  return request({
    url: `/dict/paper-types/${id}`,
    method: 'put',
    data
  });
}

export function deletePaperType(id) {
  return request({
    url: `/dict/paper-types/${id}`,
    method: 'delete'
  });
}

export function fetchQuestionTypes(params) {
  return request({
    url: '/dict/question-types',
    method: 'get',
    params
  });
}

export function createQuestionType(data) {
  return request({
    url: '/dict/question-types',
    method: 'post',
    data
  });
}

export function updateQuestionType(id, data) {
  return request({
    url: `/dict/question-types/${id}`,
    method: 'put',
    data
  });
}

export function deleteQuestionType(id) {
  return request({
    url: `/dict/question-types/${id}`,
    method: 'delete'
  });
}

// ==== 知识点树 ====
export function fetchKnowledgeNodeTree(params) {
  return cachedDictTreeGet('/dict/knowledge/nodes/tree', params);
}

/** 懒加载子节点（不走会话缓存，便于字典页展开时拿最新层） */
export function fetchKnowledgeNodeChildren(params) {
  return request({
    url: '/dict/knowledge/nodes/children',
    method: 'get',
    params
  });
}

export function fetchKnowledgeNodes(params) {
  return request({
    url: '/dict/knowledge/nodes',
    method: 'get',
    params
  });
}

export function createKnowledgeNode(data) {
  return request({
    url: '/dict/knowledge/nodes',
    method: 'post',
    data
  });
}

export function updateKnowledgeNode(id, data) {
  return request({
    url: `/dict/knowledge/nodes/${id}`,
    method: 'put',
    data
  });
}

export function deleteKnowledgeNode(id) {
  return request({
    url: `/dict/knowledge/nodes/${id}`,
    method: 'delete'
  });
}

// ==== 核心素养 / 复习提纲 ====
export function fetchCoreCompetencies(params) {
  return request({
    url: '/dict/core-competencies',
    method: 'get',
    params
  });
}

export function createCoreCompetency(data) {
  return request({
    url: '/dict/core-competencies',
    method: 'post',
    data
  });
}

export function updateCoreCompetency(id, data) {
  return request({
    url: `/dict/core-competencies/${id}`,
    method: 'put',
    data
  });
}

export function deleteCoreCompetency(id) {
  return request({
    url: `/dict/core-competencies/${id}`,
    method: 'delete'
  });
}

export function fetchReviewOutlines(params) {
  return request({
    url: '/dict/review-outlines',
    method: 'get',
    params
  });
}

export function createReviewOutline(data) {
  return request({
    url: '/dict/review-outlines',
    method: 'post',
    data
  });
}

export function updateReviewOutline(id, data) {
  return request({
    url: `/dict/review-outlines/${id}`,
    method: 'put',
    data
  });
}

export function deleteReviewOutline(id) {
  return request({
    url: `/dict/review-outlines/${id}`,
    method: 'delete'
  });
}

// ==== 扫描任务 ====
export function fetchExamScanTasks(params) {
  return request({
    url: '/exam/scan-tasks',
    method: 'get',
    params
  });
}

export function getExamScanTask(id) {
  return request({
    url: `/exam/scan-tasks/${id}`,
    method: 'get'
  });
}

export function createExamScanTask(data) {
  return request({
    url: '/exam/scan-tasks',
    method: 'post',
    data
  });
}

export function updateExamScanTask(id, data) {
  return request({
    url: `/exam/scan-tasks/${id}`,
    method: 'put',
    data
  });
}

export function deleteExamScanTask(id) {
  return request({
    url: `/exam/scan-tasks/${id}`,
    method: 'delete'
  });
}

// ==== 答卷管理 ====
export function fetchExamAnswers(params) {
  return request({
    url: '/exam/answers',
    method: 'get',
    params
  });
}

/** 考试：上传影像与学生关联策略 */
export function getExamUploadLinkPolicy(sessionId) {
  return request({
    url: `/exam/sessions/${sessionId}/upload-link-policy`,
    method: 'get'
  });
}

export function saveExamUploadLinkPolicy(sessionId, data) {
  return request({
    url: `/exam/sessions/${sessionId}/upload-link-policy`,
    method: 'put',
    data: data || {}
  });
}

/** 影像批次：人工认领 / 重识别 */
export function linkExamPaperBatch(batchId, data) {
  return request({
    url: `/exam/paper-batches/${batchId}/link`,
    method: 'put',
    data: data || {}
  });
}

export function reidentifyExamPaperBatch(batchId) {
  return request({
    url: `/exam/paper-batches/${batchId}/reidentify`,
    method: 'post'
  });
}

export function getExamAnswer(id) {
  return request({
    url: `/exam/answers/${id}`,
    method: 'get'
  });
}

export function updateExamAnswerStatus(id, status) {
  return request({
    url: `/exam/answers/${id}/status`,
    method: 'put',
    data: { status }
  });
}

// ==== 考试下发 ====
export function fetchExamDispatches(params) {
  return request({
    url: '/exam/dispatches',
    method: 'get',
    params
  });
}

export function getExamDispatch(id) {
  return request({
    url: `/exam/dispatches/${id}`,
    method: 'get'
  });
}

export function createExamDispatch(data) {
  return request({
    url: '/exam/dispatches',
    method: 'post',
    data
  });
}

export function updateExamDispatch(id, data) {
  return request({
    url: `/exam/dispatches/${id}`,
    method: 'put',
    data
  });
}

export function deleteExamDispatch(id) {
  return request({
    url: `/exam/dispatches/${id}`,
    method: 'delete'
  });
}

export function setExamDispatchStatus(id, status) {
  return request({
    url: `/exam/dispatches/${id}/status`,
    method: 'put',
    data: { status }
  });
}

// ==== 考试管理 ====
export function fetchExamSessions(params) {
  return request({
    url: '/exam/sessions',
    method: 'get',
    params
  });
}

export function getExamSession(id) {
  return request({
    url: `/exam/sessions/${id}`,
    method: 'get'
  });
}

export function fetchExamSessionStudents(sessionId) {
  return request({
    url: `/exam/sessions/${sessionId}/students`,
    method: 'get'
  });
}

export function createExamSession(data) {
  return request({
    url: '/exam/sessions',
    method: 'post',
    data
  });
}

export function updateExamSession(id, data) {
  return request({
    url: `/exam/sessions/${id}`,
    method: 'put',
    data
  });
}

export function deleteExamSession(id) {
  return request({
    url: `/exam/sessions/${id}`,
    method: 'delete'
  });
}

export function setExamSessionPublishStatus(id, publishStatus) {
  return request({
    url: `/exam/sessions/${id}/publish-status`,
    method: 'put',
    data: { publishStatus }
  });
}

/** 确保考试存在可组卷试卷，返回试卷ID */
export function ensureExamComposePaper(id) {
  return request({
    url: `/exam/sessions/${id}/compose-paper`,
    method: 'post'
  });
}

/** 绑定本场考试的 Word 试卷（先调用 uploadOssFile 上传，再传 url 与原始文件名） */
export function updateExamSessionWordPaper(sessionId, data) {
  return request({
    url: `/exam/session-word-paper/${sessionId}`,
    method: 'post',
    data
  });
}

// ==== 在线制作答题卡 ====
export function getExamAnswerSheetBySession(sessionId) {
  return request({
    url: `/exam/answer-sheets/session/${sessionId}`,
    method: 'get'
  });
}

export function saveExamAnswerSheet(data) {
  return request({
    url: '/exam/answer-sheets',
    method: 'post',
    data
  });
}

/** 答题卡用户模板（与考试主档解耦） */
export function listExamAnswerSheetTemplates(params) {
  return request({
    url: '/exam/answer-sheet-templates',
    method: 'get',
    params
  });
}

export function getExamAnswerSheetTemplate(id) {
  return request({
    url: `/exam/answer-sheet-templates/${id}`,
    method: 'get'
  });
}

export function saveExamAnswerSheetTemplate(data) {
  return request({
    url: '/exam/answer-sheet-templates',
    method: 'post',
    data
  });
}

/** 在线批阅：答卷影像批次分页 */
export function fetchExamPaperBatches(params) {
  return request({
    url: '/exam/paper-batches',
    method: 'get',
    params
  });
}

/** 阅卷标记：本场阅卷块 */
export function listExamMarkingBlocks(sessionId) {
  return request({
    url: `/exam/sessions/${sessionId}/marking-blocks`,
    method: 'get'
  });
}

export function saveExamMarkingBlocks(sessionId, data) {
  return request({
    url: `/exam/sessions/${sessionId}/marking-blocks`,
    method: 'put',
    data
  });
}

/** 阅卷标记：本场作答区域（比例坐标） */
export function listExamAnswerAreasBySession(sessionId) {
  return request({
    url: `/exam/sessions/${sessionId}/answer-areas`,
    method: 'get'
  });
}

export function saveExamAnswerAreasBySession(sessionId, data) {
  return request({
    url: `/exam/sessions/${sessionId}/answer-areas`,
    method: 'post',
    data
  });
}

/** 阅卷标记：客观题 OMR 试识别 */
export function tryChoiceOmrRecognize(sessionId, data) {
  return request({
    url: `/exam/sessions/${sessionId}/choice-omr/try`,
    method: 'post',
    data
  });
}

/** 在线批阅工作台：按 gradingStatus 分页（0~4） */
export function fetchGradingWorkbenchSessions(params) {
  return request({
    url: '/exam/grading/sessions',
    method: 'get',
    params
  });
}

/** 阅卷任务：按场查询 */
export function fetchGradingTasksBySession(examSessionId) {
  return request({
    url: `/exam/grading/tasks/session/${examSessionId}`,
    method: 'get'
  });
}

/** 阅卷任务：当前老师 */
export function fetchMyGradingTasks(examSessionId) {
  return request({
    url: '/exam/grading/tasks/mine',
    method: 'get',
    params: { examSessionId }
  });
}

/** 阅卷任务：批量分配 */
export function assignGradingTasks(examSessionId, data) {
  return request({
    url: '/exam/grading/tasks/assign',
    method: 'post',
    params: { examSessionId },
    data: data || {}
  });
}

/** 进入批改：判断是否管理员入口及可选任务 */
export function fetchGradingWorkspaceEnterInfo(examSessionId) {
  return request({
    url: '/exam/grading/workspace/enter-info',
    method: 'get',
    params: { examSessionId }
  });
}

/** 进入批改：我的工作台（管理员可传 graderStaffId 代查） */
export function fetchMyGradingWorkspace(examSessionId, gradingTaskId, graderStaffId) {
  return request({
    url: '/exam/grading/workspace/mine',
    method: 'get',
    params: {
      examSessionId,
      gradingTaskId: gradingTaskId || undefined,
      graderStaffId: graderStaffId || undefined
    }
  });
}

/** 保存批改分数 */
export function saveGradingScore(data) {
  return request({
    url: '/exam/grading/workspace/score',
    method: 'post',
    data: data || {}
  });
}

/** 更新客观题标准答案与每题分值 */
export function saveOptionStandardAnswers(sessionId, areaId, data) {
  return request({
    url: `/exam/sessions/${sessionId}/answer-areas/${areaId}/option-standard-answers`,
    method: 'put',
    data: data || {}
  });
}

/** 单考试阅卷进度 total/graded/percent（与列表列口径一致） */
export function getGradingProgress(examSessionId) {
  return request({
    url: '/exam/grading/progress',
    method: 'get',
    params: { examSessionId }
  });
}

/** 去分配 → 进入待分配（SHEET_READY） */
export function readyForAssignSession(sessionId) {
  return request({
    url: `/exam/grading/sessions/${sessionId}/ready-assign`,
    method: 'post'
  });
}

/** 去批改 → 进入批改中（GRADING） */
export function startGradingSession(sessionId) {
  return request({
    url: `/exam/grading/sessions/${sessionId}/start`,
    method: 'post'
  });
}

/** 结束批改 → 已完成（GRADES_PUBLISHED） */
export function finishGradingSession(sessionId) {
  return request({
    url: `/exam/grading/sessions/${sessionId}/finish`,
    method: 'post'
  });
}

/** 发布成绩：批阅状态 3 → 4 */
export function publishGradesSession(sessionId) {
  return request({
    url: `/exam/grading/sessions/${sessionId}/publish-grades`,
    method: 'post'
  });
}

/** 工作台上下文上传图片（追加至本场统一批次，body.imagePaths 必填） */
export function uploadGradingSessionBatch(sessionId, data) {
  return request({
    url: `/exam/grading/sessions/${sessionId}/upload`,
    method: 'post',
    data: data || {}
  });
}

/** 顺序追加单张图片（body: { imageUrl, imagesPerPaper? }） */
export function uploadGradingSessionImageOne(sessionId, data) {
  return request({
    url: `/exam/grading/sessions/${sessionId}/upload-one`,
    method: 'post',
    data: data || {}
  });
}

/** 修改每份卷图片数（清空标记与切割） */
export function setSessionImagesPerPaper(sessionId, imagesPerPaper) {
  return request({
    url: `/exam/grading/sessions/${sessionId}/images-per-paper`,
    method: 'put',
    data: { imagesPerPaper }
  });
}

/** 本场已上传图片列表 */
export function fetchSessionPaperImages(sessionId) {
  return request({
    url: `/exam/grading/sessions/${sessionId}/images`,
    method: 'get'
  });
}

/** 删除本场已上传图片（按下标） */
export function deleteSessionPaperImage(sessionId, index) {
  return request({
    url: `/exam/grading/sessions/${sessionId}/images/${index}`,
    method: 'delete'
  });
}

/** 本场排队题目切割（无需预先关联学生） */
export function triggerSessionCrop(sessionId) {
  return request({
    url: `/exam/grading/sessions/${sessionId}/crop/trigger`,
    method: 'post'
  });
}

/** 切割结果预览 */
export function fetchSessionCropPreview(sessionId) {
  return request({
    url: `/exam/grading/sessions/${sessionId}/crop-preview`,
    method: 'get'
  });
}

/** 重新按考号 OCR 关联学生（全场次） */
export function relinkSessionCrop(sessionId) {
  return request({
    url: `/exam/grading/sessions/${sessionId}/crop/relink`,
    method: 'post'
  });
}

/** 单页重新识别考号（按标记页该页考号区识别类型） */
export function relinkCropPageExamNo(sessionId, pageIndex) {
  return request({
    url: `/exam/grading/sessions/${sessionId}/crop-preview/pages/${pageIndex}/relink-exam-no`,
    method: 'post'
  });
}

/** 人工修正单页考号并重新匹配学生 */
export function saveManualExamNo(sessionId, pageIndex, examNo) {
  return request({
    url: `/exam/grading/sessions/${sessionId}/crop-preview/pages/${pageIndex}/manual-exam-no`,
    method: 'post',
    data: { pageIndex, examNo }
  });
}

/** 客观题 OMR 识别汇总 */
export function fetchChoiceOmrSummary(sessionId) {
  return request({
    url: `/exam/grading/sessions/${sessionId}/choice-omr/summary`,
    method: 'get'
  });
}

/** 人工修正客观题识别结果 */
export function saveManualChoiceAnswer(sessionId, cropId, recognizedText) {
  return request({
    url: `/exam/grading/sessions/${sessionId}/crop-preview/crops/${cropId}/manual-choice`,
    method: 'post',
    data: { cropId, recognizedText }
  });
}

export function startPaperBatchCutting(batchId) {
  return request({
    url: `/exam/paper-batches/${batchId}/start-cutting`,
    method: 'post'
  });
}

/** 与 start-cutting 等价：失败或需重跑题目切割 */
export function retryPaperBatchCutting(batchId) {
  return request({
    url: `/exam/paper-batches/${batchId}/crop/retry`,
    method: 'post'
  });
}

export function fetchPaperBatchCropStatus(batchId) {
  return request({
    url: `/exam/paper-batches/${batchId}/crop-status`,
    method: 'get'
  });
}

// ==== 考务管理 ====
export function fetchExamAffairs(params) {
  return request({
    url: '/exam/affairs',
    method: 'get',
    params
  });
}

export function getExamAffair(id) {
  return request({
    url: `/exam/affairs/${id}`,
    method: 'get'
  });
}

export function createExamAffair(data) {
  return request({
    url: '/exam/affairs',
    method: 'post',
    data
  });
}

export function updateExamAffair(id, data) {
  return request({
    url: `/exam/affairs/${id}`,
    method: 'put',
    data
  });
}

export function deleteExamAffair(id) {
  return request({
    url: `/exam/affairs/${id}`,
    method: 'delete'
  });
}

export function fetchAffairStudentCandidates(params) {
  return request({
    url: '/exam/affairs/student-candidates',
    method: 'get',
    params,
    paramsSerializer: serializeGetParams
  });
}

export function fetchAffairStudents(affairId) {
  return request({
    url: `/exam/affairs/${affairId}/students`,
    method: 'get'
  });
}

export function saveAffairStudents(affairId, data) {
  return request({
    url: `/exam/affairs/${affairId}/students`,
    method: 'put',
    data
  });
}

export function fetchAffairHistorySessions(params) {
  return request({
    url: '/exam/affairs/history-sessions',
    method: 'get',
    params
  });
}

export function getAffairArrangementRule(affairId) {
  return request({
    url: `/exam/affairs/${affairId}/arrangement-rule`,
    method: 'get'
  });
}

export function saveAffairArrangementRule(affairId, data) {
  return request({
    url: `/exam/affairs/${affairId}/arrangement-rule`,
    method: 'put',
    data
  });
}

export function fetchAffairVenues(affairId) {
  return request({
    url: `/exam/affairs/${affairId}/venues`,
    method: 'get'
  });
}

export function previewAffairVenues(affairId, data) {
  return request({
    url: `/exam/affairs/${affairId}/venues/preview`,
    method: 'post',
    data: data || {}
  });
}

export function saveAffairVenues(affairId, data) {
  return request({
    url: `/exam/affairs/${affairId}/venues`,
    method: 'put',
    data
  });
}

export function applyAffairArrangement(affairId) {
  return request({
    url: `/exam/affairs/${affairId}/arrangement/apply`,
    method: 'post'
  });
}

export function fetchAffairSeatAssignments(affairId, params) {
  return request({
    url: `/exam/affairs/${affairId}/seat-assignments`,
    method: 'get',
    params
  });
}

export function getAffairSeatAssignment(affairId, seatId) {
  return request({
    url: `/exam/affairs/${affairId}/seat-assignments/${seatId}`,
    method: 'get'
  });
}

export function createAffairSeatAssignment(affairId, data) {
  return request({
    url: `/exam/affairs/${affairId}/seat-assignments`,
    method: 'post',
    data
  });
}

export function updateAffairSeatAssignment(affairId, seatId, data) {
  return request({
    url: `/exam/affairs/${affairId}/seat-assignments/${seatId}`,
    method: 'put',
    data
  });
}

export function deleteAffairSeatAssignment(affairId, seatId) {
  return request({
    url: `/exam/affairs/${affairId}/seat-assignments/${seatId}`,
    method: 'delete'
  });
}

/** 由已排考考务一键生成各科目考试（复制名单与准考证号） */
export function generateAffairSessions(affairId, data) {
  return request({
    url: `/exam/affairs/${affairId}/generate-sessions`,
    method: 'post',
    data
  });
}

/** 考务资料 zip 导出（返回 Blob） */
export function exportExamAffair(affairId, data) {
  return axios.create({
    baseURL: '/api',
    timeout: 120000
  }).post(`/exam/affairs/${affairId}/export`, data, {
    responseType: 'blob',
    headers: {
      Authorization: store.getters['user/token'] ? `Bearer ${store.getters['user/token']}` : ''
    }
  }).then(res => res.data);
}

// ==== 作业批改 ====
export function fetchHomeworkAssignments(params) {
  return request({
    url: '/homework/assignments',
    method: 'get',
    params
  });
}

export function getHomeworkAssignment(id) {
  return request({
    url: `/homework/assignments/${id}`,
    method: 'get'
  });
}

export function createHomeworkAssignment(data) {
  return request({
    url: '/homework/assignments',
    method: 'post',
    data
  });
}

export function updateHomeworkAssignment(id, data) {
  return request({
    url: `/homework/assignments/${id}`,
    method: 'put',
    data
  });
}

export function deleteHomeworkAssignment(id) {
  return request({
    url: `/homework/assignments/${id}`,
    method: 'delete'
  });
}

export function saveHomeworkStudents(assignmentId, data) {
  return request({
    url: `/homework/assignments/${assignmentId}/students`,
    method: 'put',
    data
  });
}

export function fetchHomeworkStudents(assignmentId, params) {
  return request({
    url: `/homework/assignments/${assignmentId}/students`,
    method: 'get',
    params
  });
}

export function fetchHomeworkStudentCandidates(params) {
  return request({
    url: '/homework/assignments/student-candidates',
    method: 'get',
    params,
    paramsSerializer: serializeGetParams
  });
}

export function appendHomeworkSubmissionImages(submissionId, data) {
  return request({
    url: `/homework/submissions/${submissionId}/images`,
    method: 'post',
    data
  });
}

export function appendHomeworkStudentImages(assignmentId, studentId, data) {
  return request({
    url: `/homework/assignments/${assignmentId}/students/${studentId}/images`,
    method: 'post',
    data
  });
}

export function replaceHomeworkSubmissionImages(submissionId, data) {
  return request({
    url: `/homework/submissions/${submissionId}/images`,
    method: 'put',
    data
  });
}

export function reorderHomeworkSubmissionImages(submissionId, data) {
  return request({
    url: `/homework/submissions/${submissionId}/images/reorder`,
    method: 'put',
    data
  });
}

export function deleteHomeworkSubmissionImage(submissionId, index) {
  return request({
    url: `/homework/submissions/${submissionId}/images/${index}`,
    method: 'delete'
  });
}

export function batchBindHomeworkSubmissions(assignmentId, data) {
  return request({
    url: `/homework/assignments/${assignmentId}/submissions/batch-bind`,
    method: 'post',
    data
  });
}

export function triggerHomeworkCorrect(submissionId) {
  return request({
    url: `/homework/submissions/${submissionId}/correct/trigger`,
    method: 'post'
  });
}

export function getHomeworkCorrectStatus(submissionId) {
  return request({
    url: `/homework/submissions/${submissionId}/correct/status`,
    method: 'get'
  });
}

export function getHomeworkCorrectWorkspace(submissionId) {
  return request({
    url: `/homework/submissions/${submissionId}/correct/workspace`,
    method: 'get'
  });
}

export function saveHomeworkCorrectResults(submissionId, data) {
  return request({
    url: `/homework/submissions/${submissionId}/correct/results`,
    method: 'put',
    data
  });
}

export function createHomeworkManualQuestion(submissionId, data) {
  return request({
    url: `/homework/submissions/${submissionId}/correct/questions`,
    method: 'post',
    data
  });
}

export function deleteHomeworkQuestion(submissionId, questionResultId) {
  return request({
    url: `/homework/submissions/${submissionId}/correct/questions/${questionResultId}`,
    method: 'delete'
  });
}

export function completeHomeworkCorrect(submissionId) {
  return request({
    url: `/homework/submissions/${submissionId}/correct/complete`,
    method: 'put'
  });
}

export function publishHomeworkGrades(assignmentId) {
  return request({
    url: `/homework/assignments/${assignmentId}/publish-grades`,
    method: 'post'
  });
}

export function getHomeworkStudentAnalysis(assignmentId, studentId) {
  return request({
    url: `/homework/assignments/${assignmentId}/analysis/students/${studentId}`,
    method: 'get'
  });
}

export function generateHomeworkAiAnalysis(assignmentId, studentId) {
  return request({
    url: `/homework/assignments/${assignmentId}/analysis/students/${studentId}/ai/generate`,
    method: 'post',
    timeout: 60000
  });
}

export function getHomeworkAiWrongAdvice(assignmentId, studentId) {
  return request({
    url: `/homework/assignments/${assignmentId}/analysis/students/${studentId}/ai/wrong-advice`,
    method: 'get'
  });
}

export function getHomeworkAiTask(assignmentId, studentId, taskId) {
  return request({
    url: `/homework/assignments/${assignmentId}/analysis/students/${studentId}/ai/tasks/${taskId}`,
    method: 'get'
  });
}

export function getHomeworkAiActiveTask(assignmentId, studentId) {
  return request({
    url: `/homework/assignments/${assignmentId}/analysis/students/${studentId}/ai/active-task`,
    method: 'get'
  });
}

export function getHomeworkAiWeaknessProfile(assignmentId, studentId, params) {
  return request({
    url: `/homework/assignments/${assignmentId}/analysis/students/${studentId}/ai/weakness-profile`,
    method: 'get',
    params: params || {}
  });
}

export function getLearningWeaknessProfile(studentId, params) {
  return request({
    url: `/learning/students/${studentId}/weakness-profile`,
    method: 'get',
    params: params || {}
  });
}

export function getLearningAiWrongAdvice(id) {
  return request({ url: `/learning/ai/wrong-advice/${id}`, method: 'get' });
}

export function regenerateLearningAiWrongAdvice(id) {
  return request({ url: `/learning/ai/wrong-advice/${id}/regenerate`, method: 'post' });
}

export function getLearningAiSimilarQuestions(adviceId) {
  return request({ url: `/learning/ai/wrong-advice/${adviceId}/similar-questions`, method: 'get' });
}

export function recommendLearningAiSimilarQuestions(adviceId, params) {
  return request({
    url: `/learning/ai/wrong-advice/${adviceId}/similar-questions/recommend`,
    method: 'post',
    params: params || {}
  });
}

export function createLearningAiPractice(adviceId, params) {
  return request({
    url: `/learning/ai/wrong-advice/${adviceId}/practice`,
    method: 'post',
    params: params || {}
  });
}

// ==== AI 管理平台 ====
export function getAiProviders() {
  return request({ url: '/admin/ai/providers', method: 'get' });
}

export function getAiConfigList(params) {
  return request({ url: '/admin/ai/config', method: 'get', params });
}

export function getAiConfigDetail(id) {
  return request({ url: `/admin/ai/config/${id}`, method: 'get' });
}

export function createAiConfig(data) {
  return request({ url: '/admin/ai/config', method: 'post', data });
}

export function updateAiConfig(id, data) {
  return request({ url: `/admin/ai/config/${id}`, method: 'put', data });
}

export function deleteAiConfig(id) {
  return request({ url: `/admin/ai/config/${id}`, method: 'delete' });
}

export function fetchAiProviderModels(data) {
  return request({ url: '/admin/ai/config/fetch-models', method: 'post', data });
}

export function getAiGlobalConfig() {
  return request({ url: '/admin/ai/config/global', method: 'get' });
}

export function saveAiGlobalConfig(data) {
  return request({ url: '/admin/ai/config/global', method: 'put', data });
}

export function getAiSchoolConfig(schoolId) {
  return request({ url: `/admin/ai/config/school/${schoolId}`, method: 'get' });
}

export function saveAiSchoolConfig(schoolId, data) {
  return request({ url: `/admin/ai/config/school/${schoolId}`, method: 'put', data });
}

export function deleteAiSchoolConfig(schoolId) {
  return request({ url: `/admin/ai/config/school/${schoolId}`, method: 'delete' });
}

export function testAiConfig(data) {
  return request({ url: '/admin/ai/config/test', method: 'post', data: data || {} });
}

export function getAiPrompts(params) {
  return request({ url: '/admin/ai/prompts', method: 'get', params });
}

export function getAiEffectivePrompt(params) {
  return request({ url: '/admin/ai/prompts/effective', method: 'get', params });
}

export function getAiPromptDetail(id) {
  return request({ url: `/admin/ai/prompts/${id}`, method: 'get' });
}

export function createAiPrompt(data) {
  return request({ url: '/admin/ai/prompts', method: 'post', data });
}

export function updateAiPrompt(id, data) {
  return request({ url: `/admin/ai/prompts/${id}`, method: 'put', data });
}

export function setAiPromptDefault(id) {
  return request({ url: `/admin/ai/prompts/${id}/default`, method: 'put' });
}

export function updateAiPromptStatus(id, status) {
  return request({ url: `/admin/ai/prompts/${id}/status`, method: 'put', params: { status } });
}

export function clearAiSchoolPrompt(schoolId, sceneCode) {
  return request({ url: `/admin/ai/prompts/school/${schoolId}/${sceneCode}`, method: 'delete' });
}

export function getAiRequestLogs(params) {
  return request({ url: '/admin/ai/request-logs', method: 'get', params });
}

export function getAiRequestLogDetail(id) {
  return request({ url: `/admin/ai/request-logs/${id}`, method: 'get' });
}

